import ProviderPortal from './components/ProviderPortal';
import {connect} from 'react-redux';
import get from 'lodash/get';
import { bindActionCreators, compose } from 'redux';
import withRouter from 'react-router-dom/withRouter';

import {
  loadActiveUser,
  loadAgencies
} from '../../shared/redux/entities/actions';

import {
  invalidateImpersonateToken,
  ceaseImpersonation
} from '../../shared/redux/impersonate/actions';

import {
  invalidateAuthToken
} from '../../shared/redux/auth/actions';

import {
  showNotification,
  dismissNotification
} from '../../shared/redux/notifications/actions';

function getActiveUser(state){
  const activeUserId = get(state,['entities','activeUserId']),
    activeUser = get(state,['entities','users',activeUserId],{});

  return activeUser;
}


function mapStateToProps(state,props){
  const activeUser = getActiveUser(state);

  return {
    environment:state.version.environment,
    frontEndVersion:state.version.frontend,
    backEndVersion:state.version.backend,
    pathname:props.location.pathname,
    isLoggedIn:get(state,['auth','token']) !== null,
    isLoaded:true,
    hasAdminPermission:true,
    activeUserIsProvider:get(activeUser,['isProvider'],true),
    activeUserName:get(activeUser,['firstName']),
    activeUserAvatarURL:get(activeUser,['avatarURL']),
    notifications:state.notifications
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    loadActiveUser,
    loadAgencies,
    invalidateImpersonateToken,
    invalidateAuthToken,
    showNotification,
    dismissNotification,
    ceaseImpersonation
  },dispatch)
}

export default compose(
  withRouter,
  connect(mapStateToProps,mapDispatchToProps)
)(ProviderPortal);



// WEBPACK FOOTER //
// ./src/routes/ProviderPortal/index.js